import React, { useCallback, useState } from 'react';

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { isUndefined, isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { t } from '~/helpers';

import * as S from '../../styles';

export default function Tabela({
  title,
  cells,
  data,
  height,
  size,
  onCallback,
  onIconClick,
}) {
  const [active, setActive] = useState({});

  // click in cell table
  const handleSetActiveItem = useCallback((item) => setActive(item), []);

  const handleSubmit = useCallback(
    (item) => {
      !isEmpty(item) && onCallback(item);
    },
    [active]
  );

  const emitirCO = (idatendimento) => {
    console.log('imprimir');
    console.log(idatendimento);
  };

  return (
    <S.WrapperTabela height={height}>
      <S.WrapperTitle>{title}</S.WrapperTitle>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table" size={size}>
          <TableHead>
            <TableRow>
              {cells.map((cell, index) => (
                <>
                  {index > 0 && (
                    <TableCell
                      key={`cell-index-head-${index}`}
                      align={cell.align || 'left'}
                    >
                      {cell.label}
                    </TableCell>
                  )}
                </>
              ))}
              <TableCell key="cell-index-head-99" />
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow
                hover
                tabIndex={-1}
                key={`table-row-body-${index}`}
                onClick={() => handleSetActiveItem(item)}
              >
                {cells.map((cell, indexKey) => (
                  <>
                    {indexKey > 0 && (
                      <TableCell
                        key={`table-cell-body-${indexKey}`}
                        align={cell.align || 'left'}
                      >
                        {!isUndefined(cell.rule) && cell.rule(item) ? (
                          <input
                            id={`input-${cell.id}-${index}`}
                            type="number"
                            defaultValue={item[cell.id]}
                            onKeyUp={({ target, key }) =>
                              key === 'Enter' &&
                              cell.callback(target.value, index, item)
                            }
                            onBlur={({ target }) =>
                              cell.callback(target.value, index, item)
                            }
                          />
                        ) : cell.format ? (
                          cell.format(item[cell.id])
                        ) : (
                          item[cell.id]
                        )}
                      </TableCell>
                    )}
                  </>
                ))}
                <TableCell key="table-cell-body-99" align="right">
                  <div title={t('s.cadastro.pitstop.atendimento')}>
                    <VisibilityIcon
                      fontSize="small"
                      onClick={() => onIconClick(item.idatendimento)}
                      style={{
                        color: '#999999',
                        cursor: 'pointer',
                      }}
                    />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </S.WrapperTabela>
  );
}

Tabela.propTypes = {
  title: PropTypes.string.isRequired,
  cells: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      align: PropTypes.string,
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  height: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  onCallback: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
};

Tabela.defaultProps = {
  height: '100%',
  size: 'medium',
  onCallback: false,
};
